import styles from "./MobileHeader.module.scss";
import { HeadSearch } from "../enhancedSearch/HeadSearch/HeadSearch";
import { useNavigate, useLocation } from "react-router-dom";
import useScreenSize from "../../hooks/useScreenSize";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useState } from "react";
import classNames from "classnames";
import { ReactComponent as OnlineIcon } from "../../assets/icons/AccountWeb.svg";
import { Link } from "react-router-dom";
import AnimatedPopup from "../AnimatedComponents/AnimatedPopup";
import SideBarNavLinks from "./SideBarNavLinks";

const MobileHeader = () => {
  const push = useNavigate();
  const { isDesktop } = useScreenSize();
  const { isAppMode } = useAppModernisation();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);
  const expandSideBar = () => {
    setIsExpanded(!isExpanded);
  }

  return (
    <div>
      <div className={classNames(styles.appHeader)}>
        <button onClick={expandSideBar} className={classNames("size-12", styles.menuButton)} data-testid="expand-button">
          <i className={"tg-icons-Menu size-14"}></i>
        </button>
        <Link key="home-link" to="/">
          <img
            src="/TherapeuticGuidelines_Original_R_Logo.svg"
            alt="Therapeutic Guidelines"
            className={styles.logo}
            data-testid="expanded-logo"
          />
        </Link>
        <OnlineIcon className={styles.accountIcon} data-testid="account-icon"></OnlineIcon>
      </div>
      <AnimatedPopup show={isExpanded} fromBottom={false}>
        <div>
          <div className={classNames(styles.appHeader, styles.expandedHeader)}>
            <button onClick={expandSideBar} className={classNames("size-12", styles.menuButton)} data-testid="close-button">
              <i className={"tg-icons-Cross size-20"}></i>
            </button>
            <HeadSearch
              classicView={true}
              {...{
                push,
                isDesktop,
                isAppMode,
                searchQuery: location.search,
              }}
            />
            <OnlineIcon className={styles.accountIcon} data-testid="account-icon"></OnlineIcon>
          </div>
          <SideBarNavLinks styles={styles} isExpanded={true}></SideBarNavLinks>
        </div>
      </AnimatedPopup>
      <div onClick={expandSideBar} className={isExpanded ? styles.greyedOut : ""}></div>
    </div >
  );
};

export default MobileHeader;
